<script>
export default {
    name: "IconClock"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="" viewBox="0 0 24 24" fill="none">
        <path d="M12 8v4l2.5 2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M7 3.338A9.954 9.954 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-1.821.487-3.53 1.338-5"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
